import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Pencil from '../../Icons/Pencil';
import s from './BackgroundPicker.scss';
export var BackgroundPicker = function (_a) {
    var className = _a.className, deviation = _a.deviation, canSetCustomBackground = _a.canSetCustomBackground, firstTime = _a.firstTime, onInitialize = _a.onInitialize, showBackgroundPicker = _a.showBackgroundPicker, recordFirstTimeUse = _a.recordFirstTimeUse;
    var t = useTranslation().t;
    useEffect(function () {
        onInitialize();
    }, [onInitialize]);
    if (!canSetCustomBackground) {
        return null;
    }
    return (React.createElement("button", { className: classnames(s['trigger'], firstTime && s['FTUE'], className), onClick: function () {
            firstTime && recordFirstTimeUse();
            showBackgroundPicker(deviation);
        } },
        React.createElement(Pencil, { className: s['trigger-icon'] }),
        React.createElement("span", { className: s['trigger-text'] }, t('deviation.backgrounds.change'))));
};
export default BackgroundPicker;
//# sourceMappingURL=BackgroundPicker.js.map